module.exports = __webpack_public_path__ + "static/img/Owens.c028767.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Owens.jpg
// module id = t0hH
// module chunks = 0